export default {
      id: "eye-password-hide-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#eye-password-hide-usage",
      toString: function () {
        return this.url;
      }
    }